import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { FuelTypesService } from 'src/app/services/fuel-types/fuel-types.service';

@Component({
  selector: 'app-add-fuel-type',
  templateUrl: './add-fuel-type.component.html',
  styleUrls: ['./add-fuel-type.component.css']
})
export class AddFuelTypeComponent {

  form!: FormGroup;
    public errorMessage: string | null = null;
    public successMessage: string | null = null;
    isProcessing: boolean = false;
    submitted: boolean = false;

    constructor(
      private fuelTypesService:FuelTypesService,
      private formBuilder: FormBuilder,
      private router: Router,
      private globalService: GlobalService,
    ){
      this.form = this.formBuilder.group({
        fuel_type: ['', Validators.required],
      });
    }

    handleSubmit():void{
      this.submitted=true;
      this.isProcessing = true;

      if (this.form.valid) {
        const formData = {
          ...this.form.value,
        };

        this.fuelTypesService.save(formData).subscribe(response => {
          if(response.status==='success'){

            this.submitted=false;
            this.isProcessing = false;
            this.globalService.setGlobalSuccessMessage(response.message);

            // Redirect back to the list
            this.router.navigate(['settings/fuel-types-list']);
          }else if(response.status==='error'){
            this.submitted=false;
            this.isProcessing = false;
            this.globalService.setGlobalErrorMessage(response.message);
          }else{
            this.submitted=false;
            this.isProcessing = false;
            this.errorMessage="Oops! A problem was encountered while processing your request. Please try again or consult your system administrator.";
          }
        },
        error => {
          this.isProcessing = false;
          this.errorMessage=error;
        });
      }else{
        this.isProcessing = false;
      }
    }
}
